'use strict';
document.documentElement.classList.remove('no-js');

// Shopify owns form submission, customer consent records, inventory and checkout.
// These enhancements never store personal information or emulate provider success.
function initialiseStorefront(root = document) {
  const result = root.querySelector('[data-form-result]');
  if (result && !result.dataset.focused) {
    result.dataset.focused = 'true';
    result.focus();
  }
  const menu = root.querySelector('[data-menu-toggle]');
  if (menu && !menu.dataset.initialised) {
    menu.dataset.initialised = 'true';
    const nav = document.getElementById(menu.getAttribute('aria-controls'));
    const close = () => { menu.setAttribute('aria-expanded', 'false'); menu.setAttribute('aria-label', 'Open navigation'); nav.classList.remove('is-open'); };
    menu.addEventListener('click', () => { const open = menu.getAttribute('aria-expanded') !== 'true'; menu.setAttribute('aria-expanded', String(open)); menu.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation'); nav.classList.toggle('is-open', open); });
    document.addEventListener('keydown', event => { if (event.key === 'Escape' && menu.getAttribute('aria-expanded') === 'true') { close(); menu.focus(); } });
    document.addEventListener('click', event => { if (!event.target.closest('.site-header')) close(); });
    nav.addEventListener('click', event => { if (event.target.closest('a')) close(); });
    window.matchMedia('(min-width: 701px)').addEventListener('change', close);
  }
  root.querySelectorAll('[data-variant-selector]').forEach(selector => {
    if (selector.dataset.initialised) return;
    selector.dataset.initialised = 'true';
    selector.addEventListener('change', () => { const target = new URL(window.location.href); target.searchParams.set('variant', selector.value); window.location.assign(target.href); });
  });
  root.querySelectorAll('.signup-form').forEach(form => {
    if (form.dataset.initialised) return;
    form.dataset.initialised = 'true';
    form.addEventListener('submit', event => {
      const consent = form.querySelector('input[type="checkbox"]');
      // Native constraint validation covers normal submissions, with this guard for
      // programmatically dispatched submit events. No success is asserted in JS.
      if (!form.checkValidity() || !consent?.checked) { event.preventDefault(); form.reportValidity(); }
    });
  });
}
initialiseStorefront();
document.addEventListener('shopify:section:load', event => initialiseStorefront(event.target));
